import React from 'react';
import PropTypes from 'prop-types';
import { toClass } from 'recompose';

export const MarkerTooltip = toClass(({ penalties, locationText, t, handleRef, onAppealClick }) => {
  let markerTitle = '';
  let markerText = null;
  if (penalties.speeding) {
    markerTitle = (<p className="marker-tooltip__title">{t('journey:speeding')}
      <br />
      {t('journey:speeding_1')}
      {penalties.speeding.speedLimitExceedingMax + penalties.speeding.speeding}
      {t('journey:kmph')}
    </p>);
    markerText = `${penalties.speeding.speedLimitExceedingMax
    + penalties.speeding.speeding
    + penalties.speeding.speedLimit}${t('journey:kmph_limit')}${penalties.speeding.speedLimit}${t('journey:kmph')}`;
  }
  if (penalties.accelerating) { markerTitle = (<p className="marker-tooltip__title">{t('journey:accelerating')}</p>); markerText = null; }
  if (penalties.braking) { markerTitle = (<p className="marker-tooltip__title">{t('journey:breaking')}</p>); markerText = null; }
  if (penalties.cornering) { markerTitle = (<p className="marker-tooltip__title">{t('journey:cornering')}</p>); markerText = null; }

  return (<div ref={handleRef}>
    {markerTitle}
    <address className="marker-tooltip__address">{locationText}</address>
    {markerText && <p className="marker-tooltip__text">{markerText}</p>}
    {penalties.speeding && !penalties.braking &&
      <button
        className="button marker-tooltip__button"
        onClick={() => {
          onAppealClick();
        }}
      >{t('journey:appeal')}</button>
      }

  </div>
  );
});

MarkerTooltip.propTypes = {
  penalties: PropTypes.shape({
    speeding: PropTypes.shape({
      speeding: PropTypes.number,
      speedLimit: PropTypes.number,
      speedLimitExceedingMax: PropTypes.number,
    }),
    braking: PropTypes.shape({
      braking: PropTypes.bool,
    }),
    cornering: PropTypes.object,
    accelerating: PropTypes.object,
  }).isRequired,
  locationText: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  handleRef: PropTypes.func.isRequired,
  onAppealClick: PropTypes.func.isRequired,
  eventId: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/JourneyMap/MarkerTooltip.js